import { render } from "./orderStatusLegendModal.vue?vue&type=template&id=38c56322&ts=true"
import script from "./orderStatusLegendModal.ts?vue&type=script&lang=ts"
export * from "./orderStatusLegendModal.ts?vue&type=script&lang=ts"

import "./orderStatusLegendModal.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__